export default {"src":"/login-app/[GIT_HASH]/_next/static/media/radio_checked.54f1a1a7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};